import {IDBPDatabase, openDB} from 'idb';

/**
 * Connexion IndexedDB ouverte une seule fois et fermée dès qu'une suppression ou une mise à jour de la base
 * est demandée (logout, y compris depuis un autre onglet) : une connexion jamais fermée bloque
 * indexedDB.deleteDatabase, et toute ouverture suivante de la base reste alors en attente.
 */
export function cachedIdbConnection(name: string, storeNames: string[]): () => Promise<IDBPDatabase> {
    let connection: Promise<IDBPDatabase> | undefined;
    const reset = () => {
        connection = undefined;
    };

    return () => {
        if (!connection) {
            connection = openDB(name, 1, {
                upgrade(db) {
                    storeNames
                        .filter(storeName => !db.objectStoreNames.contains(storeName))
                        .forEach(storeName => db.createObjectStore(storeName));
                },
                blocking() {
                    const current = connection;
                    reset();
                    current?.then(db => db.close());
                },
                terminated: reset,
            });
            connection.catch(reset);
        }
        return connection;
    };
}
